// extracted by mini-css-extract-plugin
export var cancelButton = "_qy-5";
export var content = "_qy-3";
export var createButton = "_qy-6";
export var drawerContainer = "_qy-0";
export var footer = "_qy-2";
export var header = "_qy-1";
export var orderFormColumn = "_qy-4";